/* istanbul ignore file */
export enum ChargeNumbers {
    Demo = '111999000.1',
}
